import React from "react";
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { QUDA_COLORS } from "@/config/colors";
import { getChemistName } from "@/utils/textUtils";

const SupplierPharmaciesModal = ({
  open,
  onClose,
  supplierName,
  pharmacies,
  loading,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="supplier-pharmacies-modal-title"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", md: 600 },
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            id="supplier-pharmacies-modal-title"
            variant="h6"
            component="h2"
            sx={{ color: QUDA_COLORS.TEAL_DARK, fontWeight: "bold" }}
          >
            {supplierName} - Pharmacies
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress sx={{ color: QUDA_COLORS.TEAL_DARK }} />
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            sx={{ flexGrow: 1, overflow: "auto", maxHeight: "60vh" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontWeight: "bold", color: QUDA_COLORS.TEAL_DARK }}
                  >
                    Pharmacy Name
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: "bold", color: QUDA_COLORS.TEAL_DARK }}
                  >
                    Order Count
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pharmacies && pharmacies.length > 0 ? (
                  pharmacies.map((pharmacy, index) => (
                    <TableRow key={index} hover>
                      <TableCell component="th" scope="row">
                        {getChemistName(pharmacy.chemistName)}
                      </TableCell>
                      <TableCell align="right">{pharmacy.count}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No pharmacies found for this supplier in the selected date
                      range.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Modal>
  );
};

export default SupplierPharmaciesModal;
